import { isNullOrUndefined } from '@as-react/common-utils';
export const generateAbsoluteUrl = (canonicalUrl, page) => {
    let params = [];
    if (!isNullOrUndefined(page) && page > 0) {
        params = [...params, `page=${page}`];
    }
    if (params.length > 0) {
        return `${canonicalUrl}?${params.join('&')}`;
    }
    return canonicalUrl;
};
export const getQuerystringByName = (queryString, name) => {
    if (queryString.startsWith('?') || queryString.startsWith('#')) {
        queryString = queryString.substring(1);
    }
    const vars = queryString.split('&');
    for (let i = 0; i < vars.length; i++) {
        const pair = vars[i].split('=');
        let key = decodeURIComponent(pair[0] || '');
        if (key.startsWith('?'))
            key = key.substring(1);
        if (key === name)
            return decodeURIComponent(pair[1] || '');
    }
    return undefined;
};
export const setQuerystringParameter = (name, value) => {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set(name, decodeURIComponent(value));
    const newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
    history.pushState(null, '', newRelativePathQuery);
};
export const removeQuerystringParameter = (name) => {
    const url = new URL(window.location.href);
    url.searchParams.delete(name);
    const newRelativePathQuery = window.location.pathname + url.search;
    history.pushState(null, '', newRelativePathQuery);
};
export const generatePathUrl = (root, pathname, inAuthorMode, search, state) => ({
    pathname: `${root}${pathname}`,
    search: new URLSearchParams(inAuthorMode ? Object.assign(Object.assign({}, search), { wcmmode: 'disabled' }) : search).toString(),
    state,
});
